<template>
    <template v-if="transactionInfos && transactionInfos.length > 0">
        <transaction-link
            v-for="transactionInfo in transactionInfos"
            :key="transactionInfo.transactionUuid"
            class="text-primary"
            :transaction-uuid="transactionInfo.transactionUuid"
        >
            {{ transactionInfo.transactionNo }}
        </transaction-link>
    </template>
    <transaction-link v-else-if="transactionUuid" class="text-primary" :transaction-uuid="transactionUuid">
        {{ transactionNo ?? transactionName }}
    </transaction-link>
    <div v-else />
</template>

<script setup lang="ts">

import {computed, provide} from 'vue'
import TransactionLink from '@/transaction/TransactionLink.vue'
import {TransactionInfo} from '@/pending-transaction/pendingTransaction.types'

const props = defineProps({
    params: {
        type: Object as () => {
            data: any,
            context: any
        },
        required: true
    }
})

provide('panelId', props.params?.context?.panelId)
provide('panelPathSegment', props.params?.context?.panelPathSegment)

const transactionNo = computed(() => props.params.data.transactionNo)
const transactionUuid = computed(() => props.params.data.transactionUuid)
const transactionName = computed(() => props.params.data.transactionName)
const transactionInfos = computed<TransactionInfo[]>(() => props.params.data.transactionInfo)

</script>

<style scoped>

</style>